import { render, staticRenderFns } from "./TabellaAnagrafiche.vue?vue&type=template&id=3e250b76&scoped=true&"
import script from "./TabellaAnagrafiche.vue?vue&type=script&lang=js&"
export * from "./TabellaAnagrafiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e250b76",
  null
  
)

export default component.exports